import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  SR_API_ACTION_FINANCES_DELETE_MERCHANT,
} from 'api/actionTypes';
import {
  DATA_TABLE_SOURCE_MERCHANTS,
  DATA_TABLE_VIEW_ID_MERCHANTS_ALL,
} from 'common/dataTableConstants';

import postWithState from 'client/actions/postWithState';

import {
  dataTable,
  actionDataTableLoadItems,
  actionDataTableLoadNextPage,
  actionDataTableReset,
} from 'client/helpers/dataTables';

import withInfiniteScroll from 'client/helpers/withInfiniteScroll';
import SrCreateMerchantForm from 'client/components/financeAdmin/SrCreateMerchantForm';
import SrUpdateableItemValue from 'client/components/SrUpdateableItemValue';
import SrTable from 'client/components/SrTable';

@dataTable({
  dataSource: DATA_TABLE_SOURCE_MERCHANTS,
  viewId: DATA_TABLE_VIEW_ID_MERCHANTS_ALL,
  sort: {
    createdDate: 'desc',
  },
})
@withInfiniteScroll({
  offset: 32,
})
class SrDataTableMerchants extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    dispatch: PropTypes.func.isRequired,
    dataTableApiState: PropTypes.object.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
    onInfiniteScrollWrapperRef: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    const { onInfiniteScrollCallbackReady } = props;
    this.state = {
      merchantsFormActive: false,
    };
    onInfiniteScrollCallbackReady(this._infiniteScrollCallback);
  }

  _infiniteScrollCallback = () => {
    const { dataTableIsFullyLoaded, dispatch } = this.props;
    if (!dataTableIsFullyLoaded) {
      dispatch(actionDataTableLoadNextPage, {
        dataSource: DATA_TABLE_SOURCE_MERCHANTS,
        viewId: DATA_TABLE_VIEW_ID_MERCHANTS_ALL,
        count: 8,
      });
    }
  }

  _onRefreshButtonClick = () => {
    const { dispatch } = this.props;
    dispatch(actionDataTableReset, {
      dataSource: DATA_TABLE_SOURCE_MERCHANTS,
    });
  }

  _onReloadMerchantRequested = (merchantId) => {
    const { dispatch } = this.props;
    dispatch(actionDataTableLoadItems, {
      dataSource: DATA_TABLE_SOURCE_MERCHANTS,
      viewId: DATA_TABLE_VIEW_ID_MERCHANTS_ALL,
      filter: {
        id: merchantId,
      },
      count: 1,
    });
  }

  _toggleMerchantsForm = () => {
    this.setState({
      merchantsFormActive: !this.state.merchantsFormActive,
    });
  }

  _onDeleteMerchantClick = (event) => {
    const { dispatch } = this.props;
    const merchantId = parseInt(event.target.dataset.merchantId, 10);
    if (!global.confirm('Are you sure you want to delete this merchant?')) {
      return;
    }
    dispatch(postWithState, {
      action: SR_API_ACTION_FINANCES_DELETE_MERCHANT,
      payload: {
        merchantId,
      },
      onError(error) {
        global.alert(error.message);
      },
    }).then(() => {
      this._onRefreshButtonClick();
    });
  }

  render() {
    const {
      items,
      dataTableApiState,
      onInfiniteScrollWrapperRef,
      dispatch,
    } = this.props;

    const {
      merchantsFormActive,
    } = this.state;

    return (
      <div>
        <div className='adminTableTopActionsContainer'>
          <button
            type='button'
            className='button blue addEntry'
            onClick={this._toggleMerchantsForm}
          >
            register merchant
          </button>
        </div>
        {merchantsFormActive && (
          <SrCreateMerchantForm
            onMerchantCreated={(merchant) => {
              this._toggleMerchantsForm();
              this._onReloadMerchantRequested(merchant.id);
            }}
          />
        )}
        <div
          ref={onInfiniteScrollWrapperRef}
          className='tableContainer'
        >
          <button
            type='button'
            onClick={this._onRefreshButtonClick}
            className='floatButton refresh'
          />
          {dataTableApiState.error && (
            <span>ERROR: { dataTableApiState.error }</span>
          )}
          <SrTable
            headers={[
              { content: 'id' },
              { content: 'created' },
              { content: 'vendor registration number' },
              { content: 'quickbooks client id' },
              { content: 'display name' },
              { content: 'invoice email' },
              { content: 'invoice phone' },
              { content: 'actions' },
            ]}
            rows={items.map((merchant) => ({
              cells: [
                { content: merchant.id },
                { content: moment(merchant.createdDate).format('MMM Do, YYYY') },
                { content: (
                  <SrUpdateableItemValue
                    item={merchant}
                    dispatch={dispatch}
                    table='merchants'
                    fieldId='vendorRegistrationNumber'
                    onItemUpdated={this._onReloadMerchantRequested}
                    placeholder='Add Vendor Registration'
                  />
                ) },
                { content: merchant.quickbooksCustomerId || '--' },
                { content: (
                  <SrUpdateableItemValue
                    item={merchant}
                    dispatch={dispatch}
                    table='merchants'
                    fieldId='displayName'
                    validations={['required']}
                    onItemUpdated={this._onReloadMerchantRequested}
                    placeholder='--'
                  />
                ) },
                { content: (
                  <SrUpdateableItemValue
                    item={merchant}
                    dispatch={dispatch}
                    table='merchants'
                    fieldId='invoiceEmail'
                    validations={['required', 'email']}
                    onItemUpdated={this._onReloadMerchantRequested}
                    placeholder='--'
                  />
                ) },
                { content: (
                  <SrUpdateableItemValue
                    item={merchant}
                    dispatch={dispatch}
                    table='merchants'
                    fieldId='invoicePhone'
                    validations={['required', 'phone']}
                    onItemUpdated={this._onReloadMerchantRequested}
                    placeholder='--'
                  />
                ) },
                { content: (
                  <div
                    data-merchant-id={merchant.id}
                    onClick={this._onDeleteMerchantClick}
                  >
                    Delete
                  </div>
                ) },
              ],
            }))}
          />
          {dataTableApiState.inProgress && (
            <div className='loading-ellipses left' />
          )}
        </div>
      </div>
    );
  }
}

SrDataTableMerchants.displayName = 'SrDataTableMerchants';

export default SrDataTableMerchants;
